import React from 'react';

import styles from './NotFound.module.scss';

const NotFound = () => {
  return (
    <div className={styles.mainContainer}>
      <p className={styles.errorNumber}>404</p>
      <p className={styles.errorText}>Ooops, that page doesn’t exist or is unavailable.</p>
    </div>
  );
};

export default NotFound;
